import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound.tsx';
import { AdInventoryAndPricingSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/AdInventoryAndPricingSection.tsx';
import { AudienceAndReachSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/AudienceAndReachSection.tsx';
import { DirectDealsDetailsHeader } from '@openx/components-direct-deals/lib/PublisherDetails/sections/DirectDealsDetailsHeader.tsx';
import { MoreInfoSection } from '@openx/components-direct-deals/lib/PublisherDetails/sections/MoreInfoSection.tsx';
import { useDirectDealsContext } from '@openx/components-direct-deals/lib/utils/context/DirectDealsContext.tsx';
import { DirectDealsPublisherDetailsContext } from '@openx/components-direct-deals/lib/utils/context/DirectDealsPublisherDetailsContext.tsx';
import { RequestDirectDealModalProvider } from '@openx/components-direct-deals/lib/utils/context/RequestDirectDealModalContext.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { listSearchParams } from '../../utils/useListCriteria.ts';

export const DirectDealsDetailsPage = () => {
  const navigate = useNavigate();
  const { publisherId } = useParams<{ publisherId: string }>();
  const { t } = useTranslation();
  const { useDirectDealsDetailsFetch } = useDirectDealsContext();
  const { data, loading, error } = useDirectDealsDetailsFetch(publisherId || '');

  const onGoBack = () => {
    navigate(`..?${listSearchParams.directDeals ?? ''}`);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!data || error) {
    return <PageNotFound />;
  }

  const pageTitle = `${t('Details:')} ${data.name}`;

  return (
    <PageHeader titlePrefix="OpenXSelect" title={pageTitle} goBack={onGoBack}>
      <RequestDirectDealModalProvider>
        <DirectDealsPublisherDetailsContext.Provider value={{ details: data }}>
          <DirectDealsDetailsHeader />

          <AudienceAndReachSection />

          <AdInventoryAndPricingSection />

          <MoreInfoSection />
        </DirectDealsPublisherDetailsContext.Provider>
      </RequestDirectDealModalProvider>
    </PageHeader>
  );
};
